import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { Menu, Transition } from "@headlessui/react";
import ReactPaginate from "react-paginate";
import "../../../src/GlobalCssStyle.css";
//import icone
import { RiAddLine, RiPencilLine, RiSearch2Line } from "react-icons/ri";
import LimitArrow from "../../images/LimitArrow.svg"
//import tostify
import "react-toastify/dist/ReactToastify.css";
//import loader
import Loader from "../../component/Admin/Loader";
import { GetAdminRoleList, GetAdminTeamPermissionList, MasterAdminLoader, SendEmailToAdminTeamMember, UpdateAdminRoleStatus } from "../../Redux/Action/MasterAdminAction";
import { Filter, Mail } from "lucide-react";
import ClearFilter from "../../images/clear filter icon.png";
import AdminLayout from "../../component/layout/AdminLayout/AdminLayout";
import { ToastContainer } from "react-toastify";
import { AddAdminTeamRole } from "../../component/Modal/AdminModal/AddAdminTeamRole";
import TeamMemberFilter from "../../component/Modal/AdminModal/TeamMemberFilter";
import { EditAdminTeamRole } from "../../component/Modal/AdminModal/EditAdminTeamRole";

const AdminTeamMembers = () => {
    const location = useLocation();
    const history = useNavigate();
    const dispatch = useDispatch();

    const [corporatemodel, setCorporatemodel] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectpage, setselectpage] = useState("");




    const itemsPerPageOptions = [
        { value: 10, label: 10, id: 1 },
        { value: 25, label: 25, id: 2 },
        { value: 50, label: 50, id: 3 },
    ];

    useEffect(() => {
        setSearchParams(searchParams);
        const sds = location.search.slice(1).split("&");
        let object = {};
        if (location.search.includes("?")) {
            sds.map((item) => {
                let newItem = item.split("=");
                object[newItem[0]] = newItem[1];
            });
        }

        dispatch(GetAdminRoleList({ ...object }));
          dispatch(MasterAdminLoader());
        
    }, []);

    const newdata = useSelector((state) => state?.corporateData?.NewCorporate);
    const RoleList = useSelector((state) => state?.MasterAdmin?.AdminTeamMemberList);
    useEffect(() => {
        if (newdata.code === 200) {
            setCorporatemodel(false);
        }
    }, [newdata]);

    const [page, setpage] = useState("");
    const [Search, setSearch] = useState("");
    useEffect(() => {
        setpage(itemsPerPageOptions[0]?.value);
    }, []);

    // for select page data
    const onselectedpage = (item) => {
        setpage(item.value);

        const sds = location.search.slice(1).split("&");
        let object = {};
        if (location.search.includes("?")) {
            sds.map((item) => {
                let newItem = item.split("=");
                object[newItem[0]] = newItem[1];
            });

            setpage(item.value);
            setselectpage(0)
            history({
                pathname: "/admin/admin_user/team_members",
                search:
                    "?" +
                    new URLSearchParams({ ...object, limit: item.value, page: 1 }).toString(),
            });
        } else {
            history({
                pathname: "/admin/admin_user/team_members",
                search: `?limit=${item.value}`,
            });
        }
        const params = {
            ...filters,
            search: Search,
            startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
            endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
            limit: item.value,
            page: 1,
        };
        setselectpage(0);
        dispatch(GetAdminRoleList(params));
          dispatch(MasterAdminLoader());
    };

    // for pagination
    const handleFirstPage = () => {
        setselectpage(0);
        const params = {
            ...filters,
            search: Search,
            limit: searchParams.get("limit") ? searchParams.get("limit") : null,
            page: 1,
          };
        dispatch(GetAdminRoleList(params));
          dispatch(MasterAdminLoader());
    };
    const handleLastPage = () => {
        const lastPage = pageCount - 1;
        setselectpage(lastPage);
        const params = {
            ...filters,
            search: Search,
            limit: searchParams.get("limit") ? searchParams.get("limit") : null,
            page: lastPage + 1,
          };
        dispatch(GetAdminRoleList(params));
          dispatch(MasterAdminLoader());
    };
    const handlePageChange = (selected) => {
        setselectpage(selected.selected);
        const params = {
            ...filters,
            search: Search,
            limit: searchParams.get("limit") ? searchParams.get("limit") : null,
            page: selected.selected + 1,
          };
        dispatch(GetAdminRoleList(params));
          dispatch(MasterAdminLoader());
    };

    const [Itemperpage, setItemperpage] = useState("");

    const newcorporateData = useSelector(
        (state) => state?.Vfs?.BranchList?.data
    );

    const pageCount = Math.ceil(Number(RoleList?.total) / Number(page));

    
    useEffect(() => {
        if (pageCount && pageCount !== Infinity) {
            setItemperpage(pageCount);
        }
    }, [RoleList]);

    //  for search filter
    const submitsearch = (e) => {
        e?.preventDefault();
        const params = {
            ...filters,
            search: Search,
            limit: searchParams.get("limit") ? searchParams.get("limit") : null,
            page: 1,
          };
        dispatch(GetAdminRoleList(params));
          dispatch(MasterAdminLoader());
    };
    

    const [searchParams, setSearchParams] = useSearchParams();

    const removeQueryParams = () => {
        const params = {
            ...filters,
            search: '',
            limit: searchParams.get("limit") ? searchParams.get("limit") : null,
            page: 1,
          };
        dispatch(GetAdminRoleList(params));
          dispatch(MasterAdminLoader());
    setselectpage(0);

    };

    useEffect(() => {
      const newlimit = searchParams.get("limit");
      if (newlimit?.length > 0) {
        setpage(newlimit);
      }
    }, []);

    useEffect(() => {
        const newpage = searchParams.get("page");
        if (newpage?.length > 0 && newpage !== null) {
            setselectpage(Number(newpage) - Number(1));
        }
    }, [searchParams]);

    // for loader
    const loader = useSelector((state) => state?.MasterAdmin?.corporateloader);
    
    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }

    //for pagination
    const reactPaginate = {
        previousLabel: "<",
        nextLabel: ">",
        breakLabel: "",
        pageCount: Itemperpage,
        onPageChange: handlePageChange,
        containerClassName: "pagination",
        previousLinkClassName: "pagination__link",
        nextLinkClassName: "pagination__link",
        disabledClassName: "pagination__link--disabled",
        activeClassName: "pagination__link--active",
        forcePage: selectpage,
    };

      const [checkvalue, setcheckvalue] = useState("");
    // role , zone , status
    const uk_roles = [
        { value: "adaccountant", label: "Accountant" },
        { value: "adsales", label: "Sales" },
        { value: "adsupport", label: "Support" },
        { value: "admanager", label: "Manager" },
      ];
    const uk_roles_status = [
        { value: true, label: "Active" },
        { value: false, label: "Inactive" },
      ];

        const [isSidebarOpen, setIsSidebarOpen] = useState(false);
        const toggleSidebar = () => {
          setIsSidebarOpen(!isSidebarOpen);
        };
    
        const [filters, setFilters] = useState({
         role: '',
         status: '',
         zone: [],
         branchId: [],
        });
    
        
        const handleFilterChange = (newFilters) => {
          setFilters(newFilters);
          return true;
        };
    

        const getActiveFilterCount = () => {
          const activeFilters = [filters.role, filters.status !== '', filters.zone.length > 0, filters.branchId.length > 0];
          return activeFilters.filter(Boolean).length;
        };
    
        const clearAllFilters = () => {
          setFilters({
            role: '',
            status: '',
            zone: [],
            branchId: [],
          });
          handleFilterChange({
            role: '',
            status: '',
            zone: [],
            branchId: [],
          });
          setSearchParams(searchParams);
          setselectpage(0);
          dispatch(
            GetAdminRoleList({
              search: Search,
              page: 1,
            })
          );
          dispatch(MasterAdminLoader());
          setIsSidebarOpen(false);
        };
    
    
      const handelApplyFilter = (filters) => {
        setFilters(filters);
        dispatch(GetAdminRoleList({
            ...filters,
            search: Search,
        }));
          dispatch(MasterAdminLoader());
      }; 


    //  branch list get
      const [optionList, setOptionList] = useState([]);
    
        const Corporatename = useSelector(
    (state) => state?.MasterAdmin?.AllBranchListAdmin?.data
  );
      useEffect(() => {
        const con =
          Corporatename &&
          Corporatename?.map((c) => ({
            value: c._id,
            label: c.corporateName,
          }));
        setOptionList(con);
      }, [Corporatename]);

      // permission list
    
      const permissionList = useSelector(
        (state) => state?.MasterAdmin?.AdminTeamPermissionList?.pagesList
        
      );
      
      useEffect(() => {
        dispatch(GetAdminTeamPermissionList())
      }, []);
    return (
      <>
        <AdminLayout>
          {/* for Loader  */}
          {loader && (
            <div>
              <div className="fixed top-0 left-0 right-0 z-40 w-full h-full bg-black bg-opacity-50">
                <div className="z-[50] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                  <Loader />
                </div>
              </div>
            </div>
          )}

          {/* for create corporate */}
          {corporatemodel && (
            <AddAdminTeamRole
              setCorporatemodel={setCorporatemodel}
              corporatemodel={corporatemodel}
              permissionList={permissionList}
            />
          )}
          {editModalOpen && (
            <EditAdminTeamRole
              setEditModalOpen={setEditModalOpen}
              selectedRole={selectedRole}
              permissionList={permissionList}
              setSelectedPage={selectpage}
              limit={page}
            />
          )}
          <ToastContainer />
          <div className="flex flex-col h-[calc(100vh-58px)] px-5 py-5 2xl:justify-between">
            {/* --------------------------------------------Search Bar ---------------------------------------------------------- */}
            <div className="w-full p-4 mb-4 bg-white rounded-lg">
              <div className="items-center justify-between gap-3 md:flex md:gap-0">
                <div className="relative flex flex-row items-center gap-3 mt-3 md:mt-0">
                  <div className="absolute top-[8px] left-[20px] text-gray-400 text-2xl">
                    <RiSearch2Line className="w-6 h-6" />
                  </div>

                  <form
                    onSubmit={(e) => {
                      e?.preventDefault();
                      if (Search.trim() !== "") {
                        submitsearch(e);
                      }
                    }}
                  >
                    <input
                      className="h-full bg-[#FFFCE1] border rounded-[8px] py-2 pl-[50px] w-[300px] placeholder:text-[#47505F]  placeholder:text-[14px] placeholder:font-medium outline-[#FCDD00]"
                      placeholder="Search By Name, Email, Contact No"
                      value={Search}
                      onChange={(e) => {
                        const inputValue = e.target.value.trimStart();
                        setSearch(inputValue);
                        if (inputValue.trim() === "") {
                          removeQueryParams();
                        }
                      }}
                    />
                  </form>
                  <p className="text-sm font-semibold">
                    Total Member : {RoleList && RoleList?.total}
                  </p>
                </div>
                {/* <div className="mt-3 md:mt-0  w-[200px] xl:w-[300px] flex md:justify-end gap-2"> */}
                <div className=" flex flex-wrap items-center xl:justify-end rounded-[8px] gap-3">
                  {getActiveFilterCount() > 0 && (
                    <div className="z-10 flex gap-3">
                      <button
                        className="bg-[#fae006] hover:bg-[#fae006]/80 py-1 px-2 rounded-[4px] del-tooltip "
                        onClick={clearAllFilters}
                      >
                        <div className="flex items-center gap-2">
                          <img
                            src={ClearFilter}
                            className="w-7 h-7"
                            alt="new"
                          ></img>
                        </div>
                        <span className="text-sm del-tooltiptext font-Poppins">
                          Clear Filter
                        </span>
                      </button>
                    </div>
                  )}
                  <button
                    onClick={toggleSidebar}
                    className="inline-flex items-center px-4 py-2  rounded-lg text-sm font-medium  bg-[#fae006] hover:bg-[#fae006]/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                  >
                    <Filter className="w-4 h-4 mr-2" />
                    Filters
                  </button>
                  <button
                    onClick={() => setCorporatemodel(true)}
                    className="bg-[#FCDD00] text-[#1A1A1A] h-[36px] px-3 py-[6px] rounded-lg font-Poppins text-sm flex items-center gap-1 cursor-pointer  hover:scale-105"
                  >
                    <span className="text-base">
                      <RiAddLine />
                    </span>
                    Add
                  </button>
                </div>
              </div>
            </div>
            {/* --------------------------------------------Content Table------------------------------------------------------- */}
            <div className="flex-1  overflow-auto scrollbar-thumb-[#FCDD00] scrollbar-thin scrollbar-track-gray-100">
              {RoleList?.data?.length === 0 ? (
                <div className="flex items-center justify-center h-full">
                  <p className="text-xl font-Roboto">
                    No team member details available.
                  </p>
                </div>
              ) : (
                <table className="corporate-table w-[100%] text-left   font-Poppins">
                  <thead>
                    <tr style={{ zIndex: 5 }}>
                      <th>
                        <div className="pl-[40px] py-3 xl:py-3 min-w-[200px]">
                          Name
                        </div>
                      </th>
                      <th>
                        <div className="min-w-[240px]">Email Id</div>
                      </th>
                      <th>
                        <div className="min-w-[140px]">Contact No.</div>
                      </th>
                      <th>
                        <div className="min-w-[140px]">Role</div>
                      </th>
                      <th>
                        <div className="min-w-[80px]">Status</div>
                      </th>
                      <th>
                        <div className="min-w-[70px]">Action</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {RoleList?.data?.length > 0 &&
                      RoleList?.data?.map((user, index) => (
                        <tr key={index}>
                          {/* for name  */}
                          {user?.name?.length > 25 ? (
                            <td className="pl-[40px] py-2 xl:py-3 h-[46px]">
                              <div className="tooltip">
                                {`${user?.name?.substring(0, 25)}...`}
                                <span className="tooltiptext">{user.name}</span>
                              </div>
                            </td>
                          ) : (
                            <td className="pl-[40px] py-2 xl:py-3 h-[46px]">
                              <div>{user.name}</div>
                            </td>
                          )}

                          {/* for email  */}
                          {user?.email?.length > 26 ? (
                            <td>
                              <div className="tooltip">
                                {`${user?.email?.substring(0, 26)}...`}
                                <span className="tooltiptext">
                                  {user.email}
                                </span>
                              </div>
                            </td>
                          ) : (
                            <td>
                              <div>{user.email}</div>
                            </td>
                          )}

                          {/* for phone no  */}
                          <td>{user.contact}</td>
                          <td className="w-[100px] capitalize">{user.role}</td>
                          <td>
                            <div className="flex">
                              <div className="flex flex-col items-center justify-center">
                                {/* Code block starts */}
                                <div className="relative bg-gray-200 rounded-full shadow-sm cursor-pointer">
                                  <input
                                    type="checkbox"
                                    name="toggle"
                                    id={user?._id}
                                    defaultChecked={user.status == true}
                                    role="switch"
                                    onChange={(e) => {
                                      dispatch(
                                        UpdateAdminRoleStatus({
                                          id: user?._id,
                                          status: e.target.checked,
                                        },selectpage,page)
                                      );
                                      dispatch(MasterAdminLoader());
                                    }}
                                    value={checkvalue}
                                    className={`${
                                      user.status == false
                                        ? "left-0"
                                        : "right-0"
                                    } focus:outline-none checkbox w-[22px] h-[22px] mx-[3px] rounded-full bg-white absolute shadow-sm appearance-none cursor-pointer border border-transparent top-0 bottom-0 m-auto`}
                                  />
                                  <label
                                    htmlFor={user?._id}
                                    className={`${
                                      user.status == true
                                        ? "bg-[#fcdd00]"
                                        : "bg-[#dfdfdf]"
                                    }  block w-[50px] r-2 h-[26px] overflow-hidden rounded-full  cursor-pointer`}
                                  />
                                </div>
                              </div>
                              {/* Code block ends */}
                            </div>
                          </td>
                          <td className="">
                            <div className="flex items-center gap-3">
                              <span className="text-xl del-tooltip">
                              <RiPencilLine
                                className="cursor-pointer"
                                onClick={() => {
                                  setSelectedRole(user);
                                  setEditModalOpen(true);
                                }}
                              />
                              <span className="text-sm del-tooltiptext">
                                Edit
                              </span>
                            </span>
                              <span className="text-xl del-tooltip">
                                <Mail
                                  className="w-5 h-5 cursor-pointer"
                                  onClick={() => {
                                    setSelectedRole(user);
                                    dispatch(SendEmailToAdminTeamMember(user._id));
                                    dispatch(MasterAdminLoader());
                                  }}
                                />
                                <span className="text-sm del-tooltiptext">
                                  Send Mail
                                </span>
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
            </div>
            {/* --------------------------------------------Footer---------------------------------------------------------- */}
            {RoleList?.data?.length > 0 && (
              <div className="sticky bottom-0 z-10 mt-3 bg-white footer-content">
                <div className="items-center justify-between md:flex">
                  <div className="flex items-center gap-2">
                    <p className="capitalize">View</p>
                    <div className="">
                      <Menu as="div" className="relative text-left">
                        <div>
                          <Menu.Button className="flex px-[10px] ml-[10px] min-h-[37px] bg-white border-2 border-[#F2F2F2] min-w-[60px] rounded-[8px] justify-between  text-sm font-poppins font-medium  items-center ">
                            <p className="text-[#47505F] font-medium font-[poppins]">
                              {page}
                            </p>
                            <img src={LimitArrow} alt="LimitArrow" />
                          </Menu.Button>
                        </div>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="bottom-full absolute right-0 z-10 mt-2 py-2 w-[70%] rounded-[12px] bg-white shadoe-sm focus:outline-none border  mb-2">
                            {itemsPerPageOptions?.map((e) => (
                              <div key={e?.id}>
                                <Menu.Item>
                                  {({ active }) => (
                                    <p
                                      className={classNames(
                                        active
                                          ? "bg-[#FFFCE1] text-[#1A1A1A]"
                                          : "",
                                        "block px-2 py-2 text-sm cursor-pointer"
                                      )}
                                      onClick={() => onselectedpage(e)}
                                    >
                                      {e?.value}
                                    </p>
                                  )}
                                </Menu.Item>
                              </div>
                            ))}
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    </div>
                  </div>
                  {/* --------------------------------------------Footer Pagination---------------------------------------------------------- */}

                  <div className="flex items-center mt-3 md:mt-0">
                    <button
                      className="cursor-pointer text-[#000] text-sm h-[35px] border border-[#D1D5DB] px-[15px] py-[4.5px] md:py-[5.5px]"
                      onClick={handleFirstPage}
                    >
                      &lt;&lt;
                    </button>
                    <div className="hidden text-sm md:block">
                      <ReactPaginate
                        {...reactPaginate}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={3}
                      />
                    </div>
                    <div className="text-sm md:hidden">
                      <ReactPaginate
                        {...reactPaginate}
                        marginPagesDisplayed={0}
                        pageRangeDisplayed={2}
                      />
                    </div>
                    <button
                      className="cursor-pointer text-[#000] text-sm h-[35px] border border-[#D1D5DB] px-[15px] py-[4.5px] md:py-[5.5px]"
                      onClick={handleLastPage}
                    >
                      &gt;&gt;
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          {corporatemodel && (
            <div
              className="fixed inset-0 z-40 transition-opacity duration-300 bg-black bg-opacity-25"
              onClick={() => setCorporatemodel(false)}
            />
          )}
          {editModalOpen && (
            <div
              className="fixed inset-0 z-40 transition-opacity duration-300 bg-black bg-opacity-25"
              onClick={() => setEditModalOpen(false)}
            />
          )}
          {isSidebarOpen && (
            <TeamMemberFilter
              isOpen={isSidebarOpen}
              onClose={() => setIsSidebarOpen(false)}
              filters={filters}
              onFilterChange={handleFilterChange}
              optionList={uk_roles}
              statusOptions={uk_roles_status}
              Search={Search}
              setselectpage={setselectpage}
              handelFilterApply={handelApplyFilter}
            />
          )}
          {/* Overlay */}
          {isSidebarOpen && (
            <div
              className="fixed inset-0 z-40 transition-opacity duration-300 bg-black bg-opacity-25"
              onClick={() => setIsSidebarOpen(false)}
            />
          )}
        </AdminLayout>
      </>
    );
};

export default AdminTeamMembers;